<template>
  <ModalWithBackdrop
    title="Adicionar pacientes"
    v-bind="$attrs"
    className="newPatient"
    @closeclick="closeAndReset"
  >
    <h3 class="option__title">Deixe o paciente se cadastrar</h3>
    <p class="option__description">
      Encaminhe o formulário de cadastro para o paciente; Copie o link abaixo e
      envie pra quem deseja adicionar.
    </p>
    <div class="option__registerBox">
      <input
        ref="inputClinic"
        type="text"
        :class="['option__registerLink textOverflow', { success }]"
        placeholder="Nome do paciente"
        :value="inputValue"
      />
      <img class="option__copyIcon" :src="currCopyIcon" @click="copyLink" />
    </div>
    <h3 class="option__title">Cadastre-o você mesmo.</h3>
    <p class="option__description">
      Preencha manualmente o formulário de cadastro.
    </p>
    <div class="actions">
      <Button to="/patient-register" secondary> Preencher formulário </Button>
    </div>
  </ModalWithBackdrop>
</template>

<script>
import { Base64 } from 'js-base64';
import { mapGetters, mapActions } from 'vuex';
import { errorLog } from '@/utils/logger';
import ModalWithBackdrop from '@/components/ModalWithBackdrop';
import Button from '@/components/Button';
import copyIcon from '@/assets/copy-icon.png';
import successCopyIcon from '@/assets/success-copy-icon.png';
import wait from '@/utils/wait';

const icons = { copyIcon, successCopyIcon };

export default {
  name: 'NewPatient',

  components: { ModalWithBackdrop, Button },

  data: () => ({
    success: false,
    successTimer: null,
    ...icons,
  }),

  computed: {
    ...mapGetters('dashboard', ['currWorkspace']),
    inputValue() {
      const encoded = Base64.encode(this.currWorkspace.clinic.id),
        { VUE_APP_PATIENT_REGISTER_URL } = process.env;

      return `${VUE_APP_PATIENT_REGISTER_URL}/${encoded}`;
    },
    currCopyIcon() {
      return this.success ? successCopyIcon : copyIcon;
    },
  },

  methods: {
    ...mapActions('dashboard', ['closeModals']),
    copyLink() {
      const { inputClinic } = this.$refs;
      inputClinic.select();

      try {
        document.execCommand('copy');
        this.setSuccess(true);
      } catch (err) {
        this.setSuccess(false);
        errorLog(err);
        alert('Houve um problema ao copiar o link, tente copiar manualmente.');
      }
    },

    async closeAndReset() {
      this.closeModals();
      await wait(400);
      this.setSuccess(false);
    },

    setSuccess(toSuccess) {
      clearTimeout(this.successTimer);

      this.success = toSuccess;

      if (toSuccess) {
        this.successTimer = setTimeout(() => {
          this.success = false;
        }, 3000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
<style lang="scss">
@import './unscopedStyle.scss';
</style>
